import { get } from 'lodash';
import { ExactaAPI } from '../api/exactaapi';
var extractAliasValueFromProcessObject = function (processObject, alias) {
    if (processObject && alias) {
        var object = processObject[alias];
        if (object && object.content) {
            switch (object.type) {
                case 'textfield':
                case 'numberfield':
                case 'booleanfield':
                case 'role':
                case 'choicefield':
                    return object['content']['value'];
                case 'datefield':
                    return object['content']['value']['date'];
                case 'relatedprocess':
                    return object['content']['value'];
                case 'filereferencefield':
                    return object['content'];
                default:
                    return '';
            }
        }
    }
    return '';
};
var isFieldEditable = function (processObject, alias) {
    var apiVersion = ExactaAPI.getInstance().getApiVersion();
    var object;
    if (apiVersion === 2) {
        object = get(processObject, "data[" + alias + "]", '');
    }
    else {
        object = processObject.root.data.objects[alias];
    }
    if (object && object.permissions) {
        var edit = object.permissions.edit;
        return edit;
    }
    return false;
};
var extractValueFromProcessObject = function (process, alias) {
    var apiVersion = ExactaAPI.getInstance().getApiVersion();
    if (apiVersion === 2) {
        var object = get(process, "data[" + alias + "]", '');
        switch (object.type) {
            case 'booleanfield':
                return "" + object.value;
            case 'textfield':
            case 'numberfield':
                return object.value;
            case 'choicefield':
                return object.value;
            case 'filereferencefield':
                return {
                    link: object.link,
                    filename: object.filename,
                };
            case 'datefield':
                return object.value.date;
            case 'relatedprocess':
                return object.value;
            case 'role':
                return object.value;
            default:
                return '';
        }
    }
    var processObjects = get(process, 'data.root.objects', {});
    if (processObjects && alias) {
        var object = processObjects[alias];
        if (object && object.content) {
            switch (object.type) {
                case 'textfield':
                case 'numberfield':
                case 'booleanfield':
                case 'role':
                case 'choicefield':
                    return object['content']['value'];
                case 'datefield':
                    return object['content']['value']['date'];
                case 'relatedprocess':
                    return object['content']['value'];
                case 'filereferencefield':
                    return object['content'];
                default:
                    return '';
            }
        }
    }
    return '';
};
export { extractAliasValueFromProcessObject, extractValueFromProcessObject, isFieldEditable, };
//# sourceMappingURL=response.js.map